
import { defineComponent, onMounted } from "vue";
import HeaderDefault from "@/layouts/partials/HeaderDefault.vue";

export default defineComponent({
    name: "LayoutDefault",
    components: {
        HeaderDefault
    },
    setup() {
        onMounted(() => {
            // Load focus scripts for logged-in users
            const focusScript3 = document.createElement("script");
            focusScript3.src = "//mto.saldia.ch/focus/3.js";
            focusScript3.type = "text/javascript";
            focusScript3.charset = "utf-8";
            focusScript3.async = true;
            document.head.appendChild(focusScript3);

            const focusScript6 = document.createElement("script");
            focusScript6.src = "//mto.saldia.ch/focus/6.js";
            focusScript6.type = "text/javascript";
            focusScript6.charset = "utf-8";
            focusScript6.async = true;
            document.head.appendChild(focusScript6);
        });
    }
});
